"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lottie_web_1 = __importDefault(require("lottie-web"));
const registerEvents = (anim, eventListeners) => {
    eventListeners.forEach((eventListener) => {
        anim.addEventListener(eventListener.eventName, eventListener.callback);
    });
};
const deRegisterEvents = (anim, eventListeners) => {
    eventListeners.forEach((eventListener) => {
        anim.removeEventListener(eventListener.eventName, eventListener.callback);
    });
};
const getSize = (initial) => {
    let size;
    if (typeof initial === 'number') {
        size = `${initial}px`;
    }
    else {
        size = initial || '100%';
    }
    return size;
};
const Lottie = ({ options, eventListeners, isStopped, isPaused, segments, speed, direction, width, height, style, isClickToPauseDisabled, title, ariaRole, ariaLabel, }) => {
    const references = react_1.useRef({
        element: undefined,
        options: undefined,
        anim: undefined,
    });
    const pause = react_1.useCallback(() => {
        const { anim } = references.current;
        if (!anim) {
            return;
        }
        if (isPaused) {
            anim.pause();
        }
    }, [isPaused]);
    const handleClickToPause = react_1.useCallback(() => {
        const { anim } = references.current;
        if (!anim || !isClickToPauseDisabled) {
            return;
        }
        if (isPaused) {
            anim.play();
        }
        else {
            anim.pause();
        }
    }, [isClickToPauseDisabled, isPaused]);
    react_1.useEffect(() => {
        const { loop, autoplay, animationData, rendererSettings, } = options;
        if (!references.current.element) {
            return () => {
            };
        }
        if (!references.current.options) {
            references.current.options = Object.assign({ container: references.current.element, renderer: 'svg', loop: loop !== false, autoplay: autoplay !== false, animationData,
                rendererSettings }, options);
        }
        else {
            references.current.options = Object.assign(Object.assign({}, references.current.options), options);
        }
        const anim = lottie_web_1.default.loadAnimation(references.current.options);
        if (eventListeners) {
            registerEvents(anim, eventListeners);
        }
        references.current.anim = anim;
        return () => {
            if (eventListeners) {
                deRegisterEvents(anim, eventListeners);
            }
            try {
                anim.destroy();
            }
            catch (_a) {
            }
            if (references.current.options) {
                references.current.options.animationData = undefined;
            }
            references.current.anim = undefined;
        };
    }, [eventListeners, options]);
    react_1.useEffect(() => {
        if (!references.current.anim) {
            return;
        }
        const { anim } = references.current;
        if (isStopped) {
            anim.stop();
        }
        else if (segments) {
            anim.playSegments(segments);
        }
        else {
            anim.play();
        }
        pause();
        if (speed) {
            anim.setSpeed(speed);
        }
        if (direction) {
            anim.setDirection(direction);
        }
    }, [isStopped, segments, pause, speed, direction]);
    const lottieStyles = react_1.useMemo(() => (Object.assign({ width: getSize(width), height: getSize(height), overflow: 'hidden', margin: '0 auto', outline: 'none' }, style)), [style]);
    const handleReferenceAssignation = react_1.useCallback((newReference) => {
        references.current.element = newReference;
    }, []);
    return (react_1.default.createElement("div", { ref: handleReferenceAssignation, style: lottieStyles, onClick: handleClickToPause, title: title, role: ariaRole, "aria-label": ariaLabel, tabIndex: 0 }));
};
Lottie.defaultProps = {
    height: undefined,
    width: undefined,
    segments: [],
    direction: 1,
    eventListeners: undefined,
    style: {},
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: 'button',
    ariaLabel: 'animation',
    isClickToPauseDisabled: false,
    title: '',
};
exports.default = Lottie;
